module.exports = __webpack_public_path__ + "static/media/oxygen7-logo-stacked-white.f2926da4.png";